<div class="w-full h-full absolute z-5 left-0 top-0 flex align-items-center justify-content-center"
     style="background-color: rgba(147,147,147,0.71);">

    <div class="pt-8 px-8 pb-4 border-round-lg" style="background-color: rgb(255,255,255);">

        <div class="relative">
            <div *ngIf="!croppedImage" class="absolute flex justify-content-center align-items-center z-5 left-0 w-full" style="top: 25%;">
                <i class="pi pi-image text-gray-200 text-8xl"></i>
            </div>

            <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [aspectRatio]="1"
                format="png"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded($event)"
                (cropperReady)="cropperReady()"
                (loadImageFailed)="loadImageFailed()"
                class="border-1 border-round-top"
                style="width: 25vw;"
            ></image-cropper>

            <!--            <div-->
            <!--                class="overflow-hidden relative cursor-pointer overflow-hidden border-bottom-1 border-round-bottom-lg mb-3 border-x-1"-->
            <!--                (mouseenter)="isHoveringOnSelectImageButton = true" (mouseleave)="isHoveringOnSelectImageButton = false"-->
            <!--                [class.bg-blue-300]="isHoveringOnSelectImageButton">-->
            <!--                <div class="cursor-pointer py-3 font-bold text-center text-2xl">{{ 'sipo.visual-signature-image-cropper-component.select-image' | translate }}</div>-->
            <!--                <input id="imageFileSelectionInput" type="file" class="absolute w-full h-full m-0 top-0 left-0 z-5 w-full cursor-pointer opacity-0"-->
            <!--                       (change)="fileChangeEvent($event)"/>-->
            <!--            </div>-->

            <div class="flex mt-5 w-full justify-content-evenly">
                <button (click)="emitBlob(true)" class="w-5 flex justify-content-center text-center border-1 py-5 font-bold m-0 p-button p-button-outlined p-button-danger">
                    <i class="pi pi-times mr-2"></i>
                    {{ 'sipo.visual-signature-image-cropper-component.cancel' | translate }}
                </button>
                <button (click)="emitBlob(false)" class="w-5 flex justify-content-center text-center border-1 py-5 font-bold m-0 p-button p-button-outlined relative" [disabled]="!croppedImage">
                    <div *ngIf="!croppedImage" class="absolute w-full h-full z-5" style="background-color: rgba(255,255,255,0.66);"></div>
                    <i class="pi pi-check mr-2"></i>
                    {{ 'sipo.visual-signature-image-cropper-component.upload' | translate }}
                </button>
            </div>


            <!--            <div>-->
            <!--                <img [src]="croppedImage" width="300px"/>-->
            <!--            </div>-->
        </div>

    </div>
</div>
